import { connect } from 'react-redux';
import Notification from '../Notification';

const mapStateToProps = (state: any) => ({
  formSubmitted: state.contactRequestForm.formSubmitted,
  formSubmitStatus: state.contactRequestForm.formSubmitStatus,
});

export default connect(mapStateToProps)(Notification);
